import styled from 'styled-components';

import { MainContentsBox } from '@fo-components/common/styled';

const Wrapper = styled(MainContentsBox)`
  width: 1480px;
  height: 46px;
  user-select: none;
  background-color: ${(props) => props.theme.color.background.white};

  .sticky & {
    height: 0;
    visibility: hidden;
    min-width: 950px;
  }
`;

const MenuText = styled.div`
  display: flex;
  height: 46px;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 0px 24px;
  margin: 0px 1px;
  cursor: pointer;
  color: ${(props) => props.theme.color.text.basic};

  ${({ active, theme }) =>
    active
      ? `
    border: 1px solid ${theme.color.text.selected};
    border-radius: 23px;
    `
      : ''}
`;

export { Wrapper, MenuText };
